const mauveValues = {
  mauve1: {
    hsl: 'hsl(300, 26.0%, 99.0%)',
    hex: '#FDFAFE',
    rgba: 'rgba(253, 250, 254, 1)',
  },
  mauve2: {
    hsl: 'hsl(270, 20.0%, 98.0%)',
    hex: '#FAF8FE',
    rgba: 'rgba(250, 248, 254, 1)',
  },
  mauve3: {
    hsl: 'hsl(267, 13.8%, 95.3%)',
    hex: '#F8F4FC',
    rgba: 'rgba(248, 244, 252, 1)',
  },
  mauve4: {
    hsl: 'hsl(265, 12.2%, 92.7%)',
    hex: '#F4F0FA',
    rgba: 'rgba(244, 240, 250, 1)',
  },
  mauve5: {
    hsl: 'hsl(263, 11.6%, 90.3%)',
    hex: '#F0ECF9',
    rgba: 'rgba(240, 236, 249, 1)',
  },
  mauve6: {
    hsl: 'hsl(261, 11.1%, 87.7%)',
    hex: '#ECE8F7',
    rgba: 'rgba(236, 232, 247, 1)',
  },
  mauve7: {
    hsl: 'hsl(257, 10.8%, 84.3%)',
    hex: '#E8E2F5',
    rgba: 'rgba(232, 226, 245, 1)',
  },
  mauve8: {
    hsl: 'hsl(249, 10.4%, 75.5%)',
    hex: '#CFC8F0',
    rgba: 'rgba(207, 200, 240, 1)',
  },
  mauve9: {
    hsl: 'hsl(252, 6.0%, 57.3%)',
    hex: '#9391C1',
    rgba: 'rgba(147, 145, 193, 1)',
  },
  mauve10: {
    hsl: 'hsl(250, 5.0%, 52.3%)',
    hex: '#8482B8',
    rgba: 'rgba(132, 130, 184, 1)',
  },
  mauve11: {
    hsl: 'hsl(252, 5.0%, 40.7%)',
    hex: '#6B6989',
    rgba: 'rgba(107, 105, 137, 1)',
  },
  mauve12: {
    hsl: 'hsl(260, 10.0%, 13.5%)',
    hex: '#222337',
    rgba: 'rgba(34, 35, 55, 1)',
  },
};

const mauveDarkValues = {
  mauve1: {
    hsl: 'hsl(300, 5.0%, 9.5%)',
    hex: '#181317',
    rgba: 'rgba(24, 19, 23, 1)',
  },
  mauve2: {
    hsl: 'hsl(300, 7.1%, 11.0%)',
    hex: '#1C181B',
    rgba: 'rgba(28, 24, 27, 1)',
  },
  mauve3: {
    hsl: 'hsl(290, 6.2%, 16.2%)',
    hex: '#2A2628',
    rgba: 'rgba(42, 38, 40, 1)',
  },
  mauve4: {
    hsl: 'hsl(285, 5.8%, 19.5%)',
    hex: '#323031',
    rgba: 'rgba(50, 48, 49, 1)',
  },
  mauve5: {
    hsl: 'hsl(280, 5.6%, 22.4%)',
    hex: '#393737',
    rgba: 'rgba(57, 55, 55, 1)',
  },
  mauve6: {
    hsl: 'hsl(276, 5.4%, 25.7%)',
    hex: '#403D3E',
    rgba: 'rgba(64, 61, 62, 1)',
  },
  mauve7: {
    hsl: 'hsl(269, 5.3%, 30.3%)',
    hex: '#4A4748',
    rgba: 'rgba(74, 71, 72, 1)',
  },
  mauve8: {
    hsl: 'hsl(258, 5.0%, 39.2%)',
    hex: '#656164',
    rgba: 'rgba(101, 97, 100, 1)',
  },
  mauve9: {
    hsl: 'hsl(250, 5.0%, 45.0%)',
    hex: '#737173',
    rgba: 'rgba(115, 113, 115, 1)',
  },
  mauve10: {
    hsl: 'hsl(252, 4.3%, 52.3%)',
    hex: '#858285',
    rgba: 'rgba(133, 130, 133, 1)',
  },
  mauve11: {
    hsl: 'hsl(250, 6.0%, 70.5%)',
    hex: '#B5B3B5',
    rgba: 'rgba(181, 179, 181, 1)',
  },
  mauve12: {
    hsl: 'hsl(240, 7.0%, 93.8%)',
    hex: '#EDEDEF',
    rgba: 'rgba(237, 237, 239, 1)',
  },
};

export const mauve = {
  mauve1: mauveValues.mauve1.hex,
  mauve2: mauveValues.mauve2.hex,
  mauve3: mauveValues.mauve3.hex,
  mauve4: mauveValues.mauve4.hex,
  mauve5: mauveValues.mauve5.hex,
  mauve6: mauveValues.mauve6.hex,
  mauve7: mauveValues.mauve7.hex,
  mauve8: mauveValues.mauve8.hex,
  mauve9: mauveValues.mauve9.hex,
  mauve10: mauveValues.mauve10.hex,
  mauve11: mauveValues.mauve11.hex,
  mauve12: mauveValues.mauve12.hex,
} as const;

export const mauveDark = {
  mauve1: mauveDarkValues.mauve1.hex,
  mauve2: mauveDarkValues.mauve2.hex,
  mauve3: mauveDarkValues.mauve3.hex,
  mauve4: mauveDarkValues.mauve4.hex,
  mauve5: mauveDarkValues.mauve5.hex,
  mauve6: mauveDarkValues.mauve6.hex,
  mauve7: mauveDarkValues.mauve7.hex,
  mauve8: mauveDarkValues.mauve8.hex,
  mauve9: mauveDarkValues.mauve9.hex,
  mauve10: mauveDarkValues.mauve10.hex,
  mauve11: mauveDarkValues.mauve11.hex,
  mauve12: mauveDarkValues.mauve12.hex,
} as const;
